export const shuffle = (array) => {
    let currentIndex = array.length;
    while (currentIndex !== 0) {
        const randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex--;

        [array[currentIndex], array[randomIndex]] = [
            array[randomIndex], array[currentIndex]];
    }
}

export const replaceBrandDataPlaceholders = (brandData, text) => {
    if(!text) return ' '

    for (var prop in brandData) {
        if (Object.prototype.hasOwnProperty.call(brandData, prop)) {
            text = text.replaceAll(`{{${prop}}}`, brandData[prop])
        }
    }

    return text
}